export enum MonsterElement {
  None,
  Electric,
  Fire,
  Water,
  Mental,
  Nature,
  Toxic,
}
